export enum InputType {
  Checkbox,
  ColorPicker,
  Datepicker,
  Email,
  File,
  Image,
  ImageGallery,
  MultiSearch,
  MultiSelect,
  Number,
  Euros,
  RichText,
  Select,
  Tel,
  Text,
  Textarea,
  Password,
  Toggle,
  Radio,
  Time,
  MultiText,
  MultiCheckbox,
  MultiImage,
  MultiFile,
  GroupedSelect
}
